module.exports = __webpack_public_path__ + "img/pg5-left3.7f8c6ccc.png";